export enum OrderListAction {
	edit,
	delete,
	add,
	remove,
	note,
	addtopay,
	removefrompay,
}
